export default "__VITE_ASSET__ALaZLI0i__"